import { Size } from '@sgme/ui';
import { Checkbox } from 'components/shared/Checkbox/Checkbox';
import { FC, ReactNode, useCallback, useEffect, useRef } from 'react';

export type IndeterminateCheckboxValue = boolean | 'INDETERMINATE';

export interface IndeterminateCheckboxProps {
  id: string;
  e2e?: string;
  className?: string;
  size?: Size;
  isDisabled?: boolean;
  text?: string | ReactNode;
  value?: IndeterminateCheckboxValue;
  onToggle(): void;
}

export const IndeterminateCheckbox: FC<IndeterminateCheckboxProps> = ({
  id,
  e2e,
  className,
  text,
  size = 'md',
  value = false,
  onToggle,
  isDisabled = false,
}) => {
  const input = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!input || !input.current) {
      return;
    }
    input.current.indeterminate = value === 'INDETERMINATE';
  }, [value]);

  const onClick = useCallback(() => {
    if (!isDisabled) {
      onToggle();
    }
  }, [onToggle, isDisabled]);

  return (
    <Checkbox
      id={id}
      ref={input}
      e2e={e2e}
      className={className}
      size={size}
      checked={value === true}
      label={text}
      disabled={isDisabled}
      onChange={onClick}
    />
  );
};
